/**
 * Implements a Trading placeholder
 */
import Text from '../../../atoms/Text';
import { ReactComponent as SkeletonNormal } from '../images/skeleton_normal.svg';

interface ITradingPlaceholderProps {
  text: string;
  height: string | number;
}

const TradingPlaceholder = ({ text, height }: ITradingPlaceholderProps) => {
  return (
    <div className='trading' style={{ flexBasis: height }}>
      <div className='container'>
        <div className='skeleton'>
          <SkeletonNormal />
        </div>
        <div className='placeholder__text'>
          <Text size={12}>{text}</Text>
        </div>
      </div>
    </div>
  );
};

export default TradingPlaceholder;
